export default {
  apiHost: "https://service.iwanshang.cloud/industrialinternet/manage",
  uploadImgHost: "https://service.iwanshang.cloud/assets",
  webSiteApiHost: "https://service.iwanshang.cloud/industrialinternet/api",
  webSiteHttp: "https://www.gongwangtong.cn/"
};
